export default "__VITE_ASSET__Cjo9v8Ao__"